// constants.js

export const ERROR_MESSAGES = {
    INVALID_AMOUNT: "Please enter a valid amount.",
    AMOUNT_EXCEEDS_TOTAL: "Please enter an amount less than the total selected fee component value.",
    PARTIAL_PAYMENT_REG: "Partial payment is not allowed in the Registration Fees item type component.",
    MINIMUM_50_ADM: "Minimum 50% amount is required to pay for the admission fee component. Please enter a valid amount.",
    CONFIGURATION_NOT_SETUP:"Minimum  % configuration value is not done for registration or admission"
  };

  export const REG_ITEM_TYPE ='100000000029'
  export const ADM_ITEM_TYPE ='100000000030'
  export const SEQ_ITEM_TYPE ='100000000012'


  